module.exports = __webpack_public_path__ + "img/info_icon2.bed2e8eb.png";